import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteClient() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`clients/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteClient = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteClient,
    error,
    isLoading,
    reset,
  };
}
